module.exports = __webpack_public_path__ + "assets/mdm-alt.59e15e9c.svg";